//@flow
import CustomerStore from './customerStoreClass';

export default new CustomerStore();
